import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { GlobalsService } from '../../../../services/globals/globals.service';

import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { LottosService } from 'src/app/services/lottos/lottos.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./intro.component.scss']
})
export class IntroComponent implements OnInit, OnDestroy {
  public system: string;
  public lottoId = environment.lottery.lot_id;
  public subs: Subscription;
  public lotName: string;

  constructor(private _globalService: GlobalsService, protected _translate: TranslateService, protected lotto: LottosService) {
    this.system = this._globalService.getSystem().site;
  }
  ngOnInit(): void {
    this.setLottoId();
  }

  setLottoId(): void {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.lotName = lottoObj['name']?.replace(/\s+/g, '').toLowerCase();
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
